import { Client } from '@sr-sdks/api-sdk-axios';
import { CLIENTS_QUERY_DOMAIN_KEY } from '../../api/workspaces/clientApi';
import { useCachedPaginatedItem } from '../../hooks/useCachedPaginatedItem';

interface ILookupClientProps {
  id?: null | string;
}

const LookupClientName = ({ id }: ILookupClientProps) => {
  const client = useCachedPaginatedItem<Client>(
    CLIENTS_QUERY_DOMAIN_KEY,
    id === '*' ? null : id,
  );

  return (
    <strong>
      {id === '*'
        ? 'ALL CLIENTS'
        : client?.clientName.toUpperCase() || 'Unknown client'}
    </strong>
  );
};

export default LookupClientName;
